import { useState as f, useRef as i, useEffect as s } from "react";
import { FrameCommunicationAPI as m } from "../../../../js/frame-communication/index.js";
function R(n) {
  const [a, c] = f(!1), e = i(), t = i();
  s(() => {
    e.current = m.createFrameCommunication({
      // TODO: remove when we implement the frame communication API on our frontend applications
      checkProtocol: !1
    });
  }, []), s(() => {
    e.current && (c(!1), e.current.client(n).then((r) => {
      t.current = r, c(!0);
    }));
  }, [n]);
  function u(r) {
    var o;
    if (!t.current)
      throw new Error("Frame is not initialized yet!");
    return (o = t.current) == null ? void 0 : o.sendMessage(r);
  }
  return {
    isReady: a,
    sendMessage: u
  };
}
export {
  R as useFrameCommunication
};
//# sourceMappingURL=useFrameCommunication.js.map
